import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { Field } from 'redux-form'

import {
  Modal,
  Button
} from 'react-bootstrap'

import {
  renderSelectField
} from '../../Forms/fieldRenderers'

class PrinterPicker extends Component {
  constructor (props) {
    super(props)
    this.renderPrinters = this.renderPrinters.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    this.props.requestPrinters(this.props.place)
  };

  onSelect (printer) {
    const options = printer.target.options
    const label = options[options.selectedIndex].label
    if (printer) {
      this.props.setPrinter(
        this.props.place,
        printer.target.value,
        label
      )
    }
  }

  renderPrinters () {
    const {
      printers
    } = this.props

    const options = printers.map((printer, index) => {
      return (
        <option
          value={printer.nombreCola}
          key={index + 1}
        >
          {printer.nombre}
        </option>
      )
    })
    options.unshift((<option key={0} />))
    return options
  };

  render () {
    const {
      isRequesting,
      selectedPrinter,
      selectedPrinterName,
      name,
      onSubmit,
      show,
      titulo
    } = this.props
    return (
      <Modal show={show} onHide={() => null}>
        <Modal.Header>
          <span>Seleccione impresora</span>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: 'rgb(119, 181, 249)' }}>
          <h4>{titulo}</h4>
          <Field
            onChange={this.onSelect}
            name={name}
            label='Seleccione una impresora'
            component={renderSelectField}
            placeholder='Seleccione una impresora'
            value={selectedPrinter}>
            {isRequesting ? null : this.renderPrinters()}
          </Field>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: 'rgb(119, 181, 249)' }}>
          <Button
            variant='dark'
            onClick={() => onSubmit(selectedPrinter, selectedPrinterName)}
          >Seleccionar</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps (state, ownProps) {
  if (!ownProps.place || !state.printer.printers[ownProps.place]) {
    return {
      isRequesting: true,
      printers: [],
      selectedPrinter: null
    }
  };
  return {
    isRequesting: state.printer.printers[ownProps.place].requesting,
    printers: state.printer.printers[ownProps.place].items,
    selectedPrinter: state.printer.printers[ownProps.place].selected,
    selectedPrinterName: state.printer.printers[ownProps.place].selectedName
  }
};

const withRedux = connect(mapStateToProps, actions)

export default withRedux(PrinterPicker)
